import React, {FunctionComponent} from 'react';
import './styles.scss';

interface IProgressBarProps {
  progress: number;
  progressStyleClass?: string;
}

export const ProgressBar: FunctionComponent<IProgressBarProps> = ({
  progress,
  progressStyleClass
}) => {
  return <div className="progress">
    <div
      className={['progress__bar', progressStyleClass].join(' ')}
      style={{width: `${progress}%`}}
    />
  </div>;
};
